import { createStore, getActionIds } from '../helpers/redux';
import Immutable from 'immutable';

import { BaselineActions } from '../actions/baseline';
import { ProjectActions } from '../actions/project';

const baselineActions = getActionIds(BaselineActions);
const projectActions = getActionIds(ProjectActions);

const initialState = Immutable.fromJS({
  loading: false,
  loaded: false,
  baselines: {},
});

export const baselines = createStore(initialState, {
  // ['*']: (state, action) => {
  //   console.log('==> ', state.get('taggableType'));
  //   return state;
  // },

  [projectActions.resetReducers]: () => initialState,

  [baselineActions.getProjectBaselinesList.begin]: (state, action) => {
    return state.mergeDeep({
      loading: true,
      loaded: false,
    });
  },

  [baselineActions.getProjectBaselinesList.success]: (state, action) => {
    if (!action.result.entities.baselines) return state;
    return state.mergeDeep({
      loading: false,
      loaded: true,
      baselines: action.result.entities.baselines,
    });
  },

  [baselineActions.createBaseLine.begin]: state =>
    state.mergeDeep({ loading: true }),

  [baselineActions.createBaseLine.success]: (state, action) => {
    if (!action.result.entities.baselines) return state;
    return state.mergeDeep({
      baselines: action.result.entities.baselines,
      loading: false,
    });
  },

  [baselineActions.createBaseLine.failure]: state =>
    state.mergeDeep({ loading: false }),

  [baselineActions.deleteBaseLine.success]: (state, action) => {
    return state.setIn(
      ['baselines'],
      state.get('baselines').delete(action.result.baselineId),
    );
  },
});

export const baseLinesSelector = (state, props) =>
  state.baselines
    .get('baselines')
    .filter(obj => obj.get('project_id') === props.params.projectId);

export const shouldLoadBaselinesSelector = state => {
  const loading = state.reports.get('loading');
  const loaded = state.reports.get('loaded');

  return !loading && !loaded;
};



// WEBPACK FOOTER //
// ./src/reducers/baselines.js